import httpArcheo from "../helpers/http-archeo";

export const getOrganizations = async (filter = {}) => {
  try {
    const response = await httpArcheo.get(
      "/api/private/v3/organization/get",
      filter
    );
    return response?.data?.organizations;
  } catch (err) {
    throw err;
  }
};

export const saveOrganization = async (data) => {
  try {
    const response = await httpArcheo.post("/api/private/v3/organization/save", data);
    return response?.data;
  } catch (err) {
    throw err;
  }
};


export const updateOrganization = async (data) => {
  try {
    const response = await httpArcheo.put("/api/private/v3/organization/update", data);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const deleteOrganization = async (id) => {
  try {
    const response = await httpArcheo.delete(
      `/api/private/v3/organization/delete/${id}`
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};
